import {Validator} from '@/type/validation/result';
import {半角英数のみ, 必須入力, 日付書式} from '@/type/validation/validator';
import moment from 'moment';

export interface 入庫取込依頼型 {
    部署コード: string;
    登録者コード: string;
}

export interface 入庫確定依頼型 {
  入庫入力一覧: 入庫入力型[];
  入庫先部署: string;
}

export interface 入庫保存依頼型 {
  入庫入力一覧: 入庫入力型[];
  入庫先部署: string;
}

export interface 入庫入力型 {
    入庫SEQ: number;
    更新バージョン: number;
    商品コード: string;
    JANコード: string;
    販売GTINコード: string;
    メーカー名: string;
    商品名: string;
    規格容量: string;
    卸コード: string;
    入庫日付: Date;
    納入単価: number;
    入力単価: number;
    商品単価: number;
    遡及単価: number;
    入庫数: number;
    入庫遡及対象外区分: string;
    有効期限: Date;
    変更前有効期限: Date;
    ロット番号: string;
    伝票番号: string;
    伝票行番号: number;
    入力方法: string;
    有効期限入力フラグ: string;
    入庫確定区分: string;
    商品区分: string;
    入庫伝票番号: number;
    入庫伝票行番号: number;
    納品SEQ: number;
    納品データ更新バージョン: number;
    採用区分: 採用区分型;
    入庫確定不可区分: string;
    ハンディ入庫SEQ: number;
    ハンディ入庫更新バージョン: number;
    卸名: string;
}

export interface 入庫納品データ検索結果型 {
    入庫入力一覧: 入庫入力型[];
    アラートメッセージ: string;
}

export interface 入庫情報タブ入力型 {
    入庫伝票番号: string;
    入庫伝票日付: 日付型;
}

export interface 入庫納品データ検索条件型 {
    伝票日付FROM: 日付型;
    伝票日付TO: 日付型;
    卸コード: string;
    卸伝票番号: string;
}

export type 日付型 = Date | null;

export interface ハンディ入庫検索依頼型 {
    機械番号: string;
    入庫先部署コード: string;
}

export interface ハンディ入庫レコード型 {
    ハンディ入庫SEQ: number;
    更新バージョン: number;
    商品コード: string;
    ロット番号: string;
    有効期限: 日付型;
    入庫数: number;
    JANコード: string;
    販売GTINコード: string;
    商品名: string;
    規格容量: string;
    メーカー名: string;
    卸コード: string;
    機械番号: string;
    商品区分: string;
    採用区分: 採用区分型;
    卸名: string;
}

export interface ハンディ入庫取込レコード型 {
    ハンディ入庫SEQ: number;
    更新バージョン: number;
}

export interface 未確定入庫一覧取得依頼型 {
    入庫先部署コード: string;
    入庫SEQ一覧: number[];
}

export interface ハンディ入庫取込依頼型 {
    ハンディ入庫取込レコード一覧: ハンディ入庫取込レコード型[];
}

export enum 採用区分型 {
    採用品 = '採用品',
    採用品以外 = '採用品以外',
}

function 未来日時は不可(value: Date): boolean {
    if (value === null) {
        return true;
    }
    if (!日付書式(value)) {
        return true;
    }
    const momentValue = moment(value);
    const momentNow = moment(new Date());
    return momentValue.isBefore(momentNow);
}

export const 納品データ取込バリデータマップ一覧: Validator[] = [
    {
        name: '卸伝票番号',
        constraints: [
            {method: 半角英数のみ, message: '納品伝票番号は半角英数字で入力してください'},
        ],
    },
];

export const 入庫情報全指定バリデータマップ一覧: Validator[] = [
    {
        name: '入庫伝票番号',
        constraints: [
            {method: 半角英数のみ, message: '入庫伝票番号は半角英数字で入力してください'},
        ],
    },
    {
        name: '入庫伝票日付',
        constraints: [
            {method: 日付書式, message: '入庫伝票日付の書式が不正です'},
            {method: 未来日時は不可, message: '入庫伝票日付は未来の日付への変更はできません'},
        ],
    },
];
